import { Box, Button, Editable, EditablePreview, EditableTextarea, Text } from '@chakra-ui/react';
import { deleteNote, replyNote, saveNotes } from './utils';
import React from 'react';
import EditableReply from './EditableReply';
import { RiDeleteBinLine } from 'react-icons/ri';
import { TbMessageReply } from 'react-icons/tb';
import { MdOutlineQuickreply } from 'react-icons/md';

const EditableNote = ({ note, noteOrder, replyOrder, notesUtils, noteStyles }) => {
  const clear = note.cleared ? 'clear' : 'notClear';
  let date = note.date;
  let time = '';
  if (typeof note.date === 'object') {
    date = note.date.date;
    time = note.date.time;
  }
  return (
    <Box sx={{ ...noteStyles }} marginBottom="1rem">
      <Box className="editableWrapper">
        <Box className="ownerWrapper" width="5%">
          <text className="owner">{note.owner}</text>
        </Box>
        <Box className="editableTag" width="35%" background="#D7DDE8" paddingLeft=".5rem" paddingTop=".2rem" onClick={(e) => notesUtils.toggle(e,note.id)}><Text
          className="date">{date}</Text> <Text className="time">{time}</Text>
        </Box>
        <Box width="60%" background="#D7DDE8" cursor='pointer' textAlign="right" paddingRight="1rem" paddingTop=".2rem"
             onClick={(e) => notesUtils.toggle(e,note.id)}
        >+</Box>
      </Box>
      <Box id={note.id} display='none' marginLeft='5%' paddingLeft='.5rem'>
        <Editable className="editableTag" autoResize defaultValue={note.note}>
          <EditablePreview />
          <EditableTextarea onBlur={(e) => notesUtils.change(e, 'note', noteOrder)}
          />
        </Editable>
        <Box className="editNoteButtons">
          <Box className="editNoteButtonWrapper">
            <Text className="editNoteButton" onClick={() => notesUtils.delete(noteOrder)}><RiDeleteBinLine
              className="greenHover" /></Text>
          </Box>
          <Box className="editNoteButtonWrapper">
            {!notesUtils.stateProps.isAdmin && (
            <Text className="editNoteButton" onClick={(e) => notesUtils.addReply(e, noteOrder)}><MdOutlineQuickreply
              className="greenHover" /></Text>
              )}
          </Box>
        </Box>
      </Box>

    </Box>
  );

};
export default EditableNote;
